<template>
  <div v-if="theme">
    <c-row>
      <c-col md="4">
        <c-card>
          <c-card-body class="theme-info">
            <c-row>
              <c-col sm="12">
                <h1 class="h4 mb-0 mt-2">
                  <strong>{{ theme.name }}</strong>
                </h1>
                <small v-if="theme.author" v-html="theme.author" />
                <br />
              </c-col>
            </c-row>

            <c-row class="mt-3">
              <c-col sm="12">
                <p class="lead section-header font-weight-bold mb-2">Description</p>
                <small v-if="theme.description" v-html="theme.description" />
              </c-col>
            </c-row>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col md="8">
        <c-tabs class="">
          <c-tab title="Sites" active>
            <template slot="title">
              <c-icon :content="freeSet.cilBrowser" />
              Sites with this theme
              <pill :value="sites.length" />
            </template>
            <site-list :sites="sites" :show-only-require-updates="false" />
          </c-tab>
        </c-tabs>
      </c-col>
    </c-row>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import { freeSet } from '@coreui/icons';
import SiteList from '../components/site-list-for-theme';
import Pill from '../components/Pill';
import { buildEndpoint } from '../../libs/buildEndPoint';

const placeholderImage = process.env.VUE_APP_PLUGIN_PLACEHOLDER_IMAGE_URL;
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: placeholderImage,
  loading: placeholderImage,
  attempt: 1,
});

export default {
  name: 'ThemeDetails',
  components: {
    SiteList,
    Pill,
  },

  data() {
    return {
      theme: null,
      sites: null,
      freeSet,
    };
  },

  created() {
    this.themeKey = this.$route.params.themeKey;
    this.get();
  },

  updated() {
    // Force all wp links (from wp info data), to open in a new window.
    $('.theme-info a').prop('target', '_blank');
  },

  methods: {
    getPluginThumbUrl() {
      // return `https://koalaboss-app-plugin-images.s3.ap-southeast-2.amazonaws.com/${this.themeKey}.png`
      // return this.plugin.images.thumb.url;
      return '';
    },
    get() {
      this.$http
        .get(buildEndpoint('theme/sites/') + encodeURIComponent(this.themeKey))
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.sites = response.data.data.sites;
            this.theme = response.data.data.theme;
          } else {
            this.error = 'Error getting theme data';
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
.section-header {
}
.info {
  background: rgb(53, 55, 57);
  max-height: 200px;
  overflow: auto;
  //border: 1px solid #555;
  padding: 10px;
  //color: #777;
}
</style>
